<template>
  <div class="page-not-found-wrapper">
    <el-row
      align="center"
      type="flex"
      justify="center"
      class="welcome-container flex-full flex-column-items mobile-position-fixed"
    >
      <div class="page-not-found paflex-full-xs text-center">
        <h1>{{ $t('page-not-found.title') }}</h1>
        <router-link
          tag="el-button"
          :to="{ name: 'Home' }"
        >
          <i class="icon-real_estate" /> {{ $t('home-button.text') }}
        </router-link>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
};
</script>



// WEBPACK FOOTER //
// src/pages/PageNotFound.vue